import { configureStore } from '@reduxjs/toolkit';
import customerReducer from './slices/customerSlice';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import searchReducer from './slices/searchSlice';

export const store = configureStore({
  reducer: {
    customer: customerReducer,
    auth: authReducer,
    user: userReducer,
    search: searchReducer,
  },
});
